export const PRICE_PREDICTION_PRICE_WATCH_TITLE = "Price Prediction and Alerts";
export const PRICE_PREDICTION_PRICE_WATCH_SUBTITLE = "Terms and Conditions";
export const PRICE_PREDICTION_PRICE_WATCH_BODY = "Pending";
